var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gmap-map',{staticClass:"map",attrs:{"center":_vm.mapCenter,"options":_vm.mapConfig}},_vm._l((_vm.getLocations),function(marker,index){return (_vm.appIsActive)?_c('gmap-marker',{key:index,attrs:{"position":marker.coords,"clickable":true,"draggable":false,"animation":2,"icon":{
      url: _vm.getSVGmarker(_vm.getActiveLocation && marker.id === _vm.getActiveLocation.id, index + 1),
      scaledSize: { width: 52, height: 66 }
    }},on:{"click":function($event){_vm.setActiveLocation(marker)}}}):_vm._e()}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f420daba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VuegleMaps.vue
// module id = null
// module chunks = 